import { defineComponent as _defineComponent } from 'vue';
import { computed } from "vue";
import { objectStoreTemplateTypes, ObjectStoreValidFilters } from "@/api/objectStores.templates";
import { useObjectStoreTemplatesStore } from "@/stores/objectStoreTemplatesStore";
import { useUserStore } from "@/stores/userStore";
import SourceOptionsList from "@/components/ConfigTemplates/SourceOptionsList.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'CreateUserObjectStore',
    setup(__props) {
        const breadcrumbItems = [
            { title: "User Preferences", to: "/user" },
            { title: "Galaxy Storage", to: "/object_store_instances/index" },
            { title: "Create New" },
        ];
        const userStore = useUserStore();
        const objectStoreTemplatesStore = useObjectStoreTemplatesStore();
        objectStoreTemplatesStore.ensureTemplates();
        const currentListView = computed(() => userStore.currentListViewPreferences.objectStoreOptions || "grid");
        const templates = computed(() => objectStoreTemplatesStore.latestTemplates);
        return { __sfc: true, breadcrumbItems, userStore, objectStoreTemplatesStore, currentListView, templates, objectStoreTemplateTypes, ObjectStoreValidFilters, SourceOptionsList };
    }
});
